export default "__VITE_ASSET__Dl5vS3iH__"